/*
    Hook que gestiona el título de la pestaña del navegador (document.title) en función de la ruta activa,
    sirviendo como un respaldo a nivel de Layout para garantizar que todas las vistas tengan un título válido 
    y consistente.

    Puntos clave:
        Piso de SEO automático: Garantiza que cualquier vista exponga un título válido con el formato 
        "Sección | Marca" sin depender de que cada componente individual implemente etiquetas SEO locales.

        Sincronización por useLayoutEffect: Se ejecuta sincrónicamente antes de que el navegador dibuje la 
        pantalla. Esto permite que el Layout defina un título base antes de que componentes de vista específicos 
        (como <AppSeo/>) puedan sobreescribirlo voluntariamente durante su ciclo de useEffect.

        Algoritmo de coincidencia inteligente:
            Busca primero un coincidencia exacta (end: true) con la ruta actual.
            Si no la hay (ej. rutas dinámicas como /blog/:slug), busca una coincidencia parcial omitiendo la 
            raíz (/) y priorizando el path más largo/específico.
            Diseño desacoplado: Recibe la lista de rutas y el nombre de la marca como parámetros externos, 
            evitando dependencias rígidas de configuración para facilitar su reusabilidad en otros proyectos.
*/

import { useLayoutEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";


export const useSectionMetaTitle = (routes = [], siteName = "") => {

    const LOCATION = useLocation();

    useLayoutEffect(() => {

        if (!siteName || typeof document === "undefined") return;

        const CANDIDATES = (routes ?? []).filter((r) => r?.path && r?.label);

        const EXACT = CANDIDATES.find((r) => matchPath({ path: r.path, end: true }, LOCATION.pathname));

        const PARTIAL = CANDIDATES.filter((r) => r.path !== "/" && matchPath({ path: r.path, end: false }, LOCATION.pathname)).sort((a, b) => b.path.length - a.path.length)[0];

        const HIT = EXACT ?? PARTIAL;

        document.title = HIT?.label ? `${HIT.label} | ${siteName}` : siteName;

    }, [LOCATION.pathname, routes, siteName]);
};

export const useSectionTitle = useSectionMetaTitle;
